import "./index.css";
import Textarea from "../../../layout/Textarea/Textarea";
import LivestreamBackground from "../LivestreamBackground";
import cn from "classnames";
import {useEdits} from "../../../contexts/edits";
import {useSetting} from "../../../contexts/setting";

// 1080×1920 — Instagram Stories livestream title card (Figma 4238:1200).
// Header + editable title + date/time; no speaker photos or upload zone.
// Shown only when layout 6 is selected (filtered in ../index.js) — it's the
// first Instagram Stories template; LivestreamStories is the second one.
const LivestreamStoriesIntro = ({id, zoom}) => {
  const {titles, dates, times} = useEdits();
  const {titleFontSize} = useSetting();

  const title = titles[id] || titles.main;
  const date = dates[id] || dates.main;
  const time = times[id] || times.main;

  return (
    <div id={id} className="template livestream livestream-tpl" style={{"--zoom-level": zoom}}>
      <div className="livestream-tpl__inner">
        <LivestreamBackground id={id} />

        <div className="content">
          <header className="ls-header">JetBrains | Livestream</header>

          {/* Title + date flow in a column (Figma Frame 14, gap 90px) so the
           * date is pushed down as the title grows — never overlapped. */}
          <div className="ls-main">
            <h1 className={cn("title", {"title--small": titleFontSize === "small"})}>
              <Textarea id={id} text={title} />
            </h1>

            <div className="ls-when">
              <div className="date">
                <Textarea id={id} text={date} />
              </div>
              <div className="time">
                <Textarea id={id} text={time} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LivestreamStoriesIntro;
